import { render, staticRenderFns } from "./AdminApp.vue?vue&type=template&id=f3fc7a92"
import script from "./AdminApp.vue?vue&type=script&lang=js"
export * from "./AdminApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports